export enum InlineSelectorValidationErrors {
  RangeMustBeInSameNode = "inline-selector.range-must-be-within-same-node",
  SelectionsCannotOverlap = "inline-selector.selections-cannot-overlap",
  NodeDoesNotSupportPiping = "inline-selector.node-does-not-support-piping"
}
